import { module } from 'modujs';
import { html } from '../utils/environment';
import { getFirstFocusableElement } from '../utils/getFirstFocusableElement'

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                share: 'share',
                close: 'close'
            }
        }
    }

    init() {

        this.$copy = this.$('copy')[0];

        this.closeBind = (e) => {
            if (e.key === "Escape") {
               this.close();
           }
       }

       document.addEventListener('keyup', this.closeBind)

       this.el.inert = true
    }

    share(e) {
        const el = e.curTarget;
        const platform = this.getData('platform', e.curTarget)
        const url = window.location.href
        let shareUrl;

        switch(platform) {
            case 'facebook':
                shareUrl = 'https://facebook.com/sharer/sharer.php?u=' + url;
                this.openWindow(shareUrl);
                break;

            case 'twitter':
                shareUrl = 'https://twitter.com/share?url=' + url
                         + '&amp;text=' + encodeURIComponent(this.getData('text', e.curTarget))
                this.openWindow(shareUrl);
                break;

            case 'mail':
                const subject = encodeURIComponent(this.getData('subject', e.curTarget))
                const body = encodeURIComponent(this.getData('body', e.curTarget))
                this.openMail(subject, body);
                break;

            case 'linkedin':
                shareUrl = `http://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}`;
                this.openWindow(shareUrl);
            break;

            case 'copy':
                this.copyUrl(url);
                break;
        }
    }

    openWindow(url) {
        window.open(url, 'Share', 'menubar=no, toolbar=no, resizable=yes, scrollbars=yes, height=500, width=600');
    }

    openMail(subject, body) {
        window.location = 'mailto:?subject=' + subject + '&body=' + body;
    }

    copyUrl(url) {
        if(this.copyTimeout != undefined) {
            clearTimeout(this.copyTimeout);
        }
        this.$copy.innerText = this.getData('copy-success');

        this.copyTimeout = setTimeout(() => {
            this.$copy.innerText = this.getData('copy-label');
        }, 1500)

        window.copyToClipboard(url)
    }

    open(param) {
        this.el.inert = false
        const $main = document.querySelector('main')
        $main.inert = true

        setTimeout(() => {
            getFirstFocusableElement(this.el)
        }, 100);

        html.classList.add('has-share-open');
    }

    close() {
        this.el.inert = true
        const $main = document.querySelector('main')
        $main.inert = false

        html.classList.remove('has-share-open');
    }

    destroy() {
        super.destroy()

        document.removeEventListener('keyup', this.closeBind)
    }
}
